module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_2.2f89633b.jpg";